import { ajaxSend, ApiErrorStatusCode } from '../../../api/api';
const basePath = '/v1/webhooks';
export function getSubscription(id) {
    return ajaxSend({
        path: `${basePath}/subscriptions/${id}`,
    });
}
export function getSubscriptions() {
    return ajaxSend({
        path: `${basePath}/subscriptions`,
    });
}
export function getEvents() {
    return ajaxSend({
        path: `${basePath}/fqns`,
    });
}
export function addSubscription({ name, fqns, url, user_supplied_headers, is_enabled, }) {
    return ajaxSend({
        method: 'POST',
        path: `${basePath}/subscriptions`,
        data: {
            name,
            fqns,
            url,
            user_supplied_headers,
            is_enabled,
        },
        ignoreErrorCodes: [ApiErrorStatusCode.Conflict],
    });
}
export function deleteSubscription(id) {
    return ajaxSend({
        method: 'DELETE',
        path: `${basePath}/subscriptions/${id}`,
    });
}
export function updateSubscription({ id, name, fqns, url, user_supplied_headers, is_enabled, }) {
    return ajaxSend({
        method: 'PATCH',
        path: `${basePath}/subscriptions/${id}`,
        data: {
            name,
            fqns,
            url,
            user_supplied_headers,
            is_enabled,
        },
        ignoreErrorCodes: [ApiErrorStatusCode.Conflict],
    });
}
export function getEventLog(payload) {
    const { id, event } = payload;
    return ajaxSend({
        path: `${basePath}/delivery_events/${id}/${event}`,
    });
}
export function getDeliveryStatus(id) {
    return ajaxSend({
        path: `${basePath}/delivery_statuses/${id}`,
    });
}
